'use client';

import {autocomplete} from '@algolia/autocomplete-js';
import PropTypes from 'prop-types';
import {createElement, Fragment, useEffect, useRef} from 'react';
import {createRoot} from 'react-dom/client';
import {sendTrackingData} from '../utils/tracking';

const addQaIdLocator = (containerRef, selector, qaId) => {
  const el = containerRef.current.querySelector(selector);
  if (el) {
    el.setAttribute('data-qa-id', qaId);
  }
};

export const AutoCompleteSearchBar = ({classNames, ref, onInstanceCreated, ...props}) => {
  const panelRootRef = useRef(null);
  const rootRef = useRef(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: ref is a ref
  useEffect(() => {
    if (!ref.current) {
      return undefined;
    }
    const search = autocomplete({
      container: ref.current,
      detachedMediaQuery: 'none',
      // biome-ignore lint/suspicious/noEmptyBlockStatements: Fix me!
      renderer: {createElement, Fragment, render: () => {}},
      renderNoResults({render: renderElem, root}) {
        renderElem(null, root);
      },
      render({elements, html}, root) {
        if (!panelRootRef.current || rootRef.current !== root) {
          rootRef.current = root;

          panelRootRef.current?.unmount();
          panelRootRef.current = createRoot(root);
        }
        panelRootRef.current.render(
          html`<div className=${classNames.panelLayout}>
            <div>
              <div>${elements['invitation-suggestion']}</div>
              <div>${elements['invitation-template']}</div>
              <div>${elements['card-suggestion']}</div>
              <div>${elements['card-template']}</div>
            </div>
          </div>`
        );
      },
      classNames,
      ...props,
    });

    // Store the autocomplete instance for global click handling
    if (onInstanceCreated) {
      onInstanceCreated(search);
    }

    addQaIdLocator(ref, '.search-bar__input', 'input-search-bar');
    addQaIdLocator(ref, '.aa-SubmitButton.search-bar__input--icons', 'submitSearchQueryIconButton');

    return () => {
      search.destroy();
    };
    // biome-ignore lint/correctness/useExhaustiveDependencies: existing functionality
  }, [props, classNames, onInstanceCreated]);

  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: not worth fixing right now
    // biome-ignore lint/a11y/noStaticElementInteractions: not worth fixing right now
    <div
      id="autocomplete-input"
      data-qa-id="meganavSearchInput"
      ref={ref}
      onClick={() => {
        sendTrackingData('template_search_engagement_tracking', {
          searchBarLocation: props.searchBarLocation,
        });
      }}
    />
  );
};

AutoCompleteSearchBar.propTypes = {
  classNames: PropTypes.objectOf(PropTypes.string),
};
